import { constants } from '../constants/fichaOptometrica.constants';

export const getUsuarios = (payload: any) => ({
  type: constants.GET_USUARIOS_REQUEST,
  payload,
});

export const getPrescriptores = (payload: any) => ({
  type: constants.GET_PRESCRIPTORES_REQUEST,
  payload,
});

export const getGraduaciones = (pacienteId: string) => ({
  type: constants.GET_GRADUACIONES_REQUEST,
  payload: { pacienteId },

});

export const getOldGraduacion = () => ({
  type: constants.GET_OLD_GRADUACION_REQUEST,
});
export const getGraduacion = (codigo: string, tiendaGraduacion: string) => ({
  type: constants.GET_GRADUACION_REQUEST,
  payload: { codigo, tiendaGraduacion },
});

export const getGraduacionExtendida = (codigo: string) => ({
  type: constants.GET_GRADUACION_EXTENDIDA_REQUEST,
  payload: { codigo },
});

export const setGraduacion = ({ pacienteId, codigo, data }: any) => ({
  type: constants.SET_GRADUACION_REQUEST,
  payload: {
    pacienteId,
    codigo,
    data,
  },
});
